import { StateSliceDefaults, StateSliceName } from '@oneapp/main/core/store.models';

export interface EditBundleRouterState {
    message?: string;
    displayCreateAnotherBundleButton?: boolean;
}

export enum EditBundleDataCySelector {
    PAGE_TITLE = 'edit-bundle-page-title',
    BUNDLE_DETAILS_TAB = 'bundle-details-tab',
    LEAGUES_SEASONS_TEAMS_TAB = 'leagues-seasons-teams-tab',
    INDIVIDUAL_GAMES_TAB = 'individual-games-tab',
    INVALID_BUNDLE_WARNING = 'invalid-bundle-warning',
    NO_PERMISSION_WARNING = 'no-permission-warning'
}

export interface EditBundleStateModel {
    bundleId: string | undefined;
}

export const editBundleStateDefaults: StateSliceDefaults<EditBundleStateModel> = Object.freeze({
    sliceName: StateSliceName.EDIT_BUNDLE,
    defaults: {
        bundleId: undefined
    }
});
